// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__y-z0W","disabled":"FileBtn_disabled__2tzSt","warn":"FileBtn_warn__2YaNy","fade":"FileBtn_fade__S63mm"};